import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { TIME_ZONES } from 'src/app/account-settings/account-settings.data';
import { ABPService } from '../../abp.service';
import { AbpLocationsFilterService } from '../../services/abp-locations-filter.service';
import { SessionService } from 'src/app/core/backend-adapter/session.service';

@Component({
  selector: 'app-abp-date-locations-form',
  templateUrl: './abp-date-locations-form.component.html',
  styleUrls: ['./abp-date-locations-form.component.scss'],
})
export class AbpDateLocationsFormComponent implements OnInit, OnChanges, OnDestroy {
  timeZones = [];
  locations = [];
  isSelectedAll: boolean;
  selectedLocationsLength: number;
  current = 0;
  currentLocations = [];
  // paginatorRows = 500;
  // paginatorLength = 0;
  filterValue = '';
  filtered = [];
  unsubscribe$ = new Subject<void>();
  @Input() scheduleGroup: FormGroup;
  @Input() rows: number;
  @Input() width = '100%';
  @Input() displayScheduleLaterSwitch: boolean;
  public disableScheduleForLaterSwitch: boolean = false;
  public preSelectedLocs: any[] = [];
  totalLocationsCount: number = 0; // Total count from API

  // Location Filter Modal properties
  showLocationFilterModal = false;
  /** True while Apply filter API request is in progress. */
  applyFiltersLoading = false;
  isAndMode: boolean = false; // AND/OR toggle (true = AND, false = OR)
  selectedFilters: { [key: string]: string[] } = {};
  private draftSelectedFilters: { [key: string]: string[] } = {};
  filteredLocations: any[] = []; // Store filtered locations for display
  showFilteredLocationsDropdown = false; // Control visibility of filtered locations dropdown
  selectedFilteredLocationsForDisplay: any[] = []; // Store selected locations for dropdown display
  private locationsLoaded = false; // Track if locations have been loaded to avoid redundant API calls
  filterCategories = [
    { label: 'Store code', key: 'storeCode', options: [], expanded: false },
    { label: 'Business name', key: 'businessName', options: [], expanded: false },
    { label: 'City', key: 'city', options: [], expanded: false },
    { label: 'State', key: 'state', options: [], expanded: false },
    /*{ label: 'Country', key: 'country', options: [], expanded: false },*/
    /*{ label: 'Tags', key: 'tags', options: [], expanded: false },*/
    /*{ label: 'Labels', key: 'labels', options: [], expanded: false }*/
  ];
  trackCatByKey = (_: number, cat: { key: string }) => cat.key;
  trackOption = (_: number, opt: string) => opt;
  /** Selected account id (same as listings: from getSelectedAccount$()). */
  private currentAccountId: number;
  /** Current user login id (same as listings: from getCurrentUser$()). */
  private userLoginId: number;

  constructor(
    private abpService: ABPService,
    private locationsFilterService: AbpLocationsFilterService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    // Fetch account and user the same way as listings.component
    this.sessionService.getSelectedAccount$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((account) => {
        this.currentAccountId = account?._id;
      });
    this.sessionService.getCurrentUser$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) => {
        this.userLoginId = user?.login?._id;
      });

    // Load locations from /access/filters API (will use cache if available)
    this.loadLocationsFromFiltersAPI();

    if (this.displayScheduleLaterSwitch) {
      if (!this.scheduleGroup.controls['timeZone'].value) {
        this.scheduleGroup.addControl('checked', new FormControl(false));
      }
      // To disable Schedule for Later switch if Post status === A (Active).
      if (this.scheduleGroup.controls['postStatus']?.value) {
        this.disableScheduleForLaterSwitch = true;
      }
    }

    this.scheduleGroup.controls.isSelectedAll.valueChanges
      .pipe(takeUntil(this.unsubscribe$), debounceTime(200))
      .subscribe((value) => {
        if (value) {
          this.scheduleGroup.controls.location.setValue(this.locations);
          this.fetchCtasDataForSelectAll();
        } else {
          this.scheduleGroup.controls.location.setValue([]);
          this.setCtaSummaryFromFilterApply(null);
          this.setCtaFiltersQueryParamsSnapshot({});
        }
      });
    this.scheduleGroup.controls.location.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      if(value.length === (this.locations.length)) {
        this.scheduleGroup.controls.isSelectedAll.setValue(true, { emitEvent: false });
        // this.scheduleGroup.patchValue({
        //   isSelectedAll: true
        // })
      } else {
        this.scheduleGroup.controls.isSelectedAll.setValue(false, { emitEvent: false });
        // this.scheduleGroup.patchValue({
        //   isSelectedAll: true
        // })
      }
    });

    if(this.preSelectedLocs.length) {
      this.scheduleGroup.controls.location.setValue([]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.scheduleGroup.currentValue['controls']['timeZone'].value) {
      this.scheduleGroup.patchValue({
        checked: true
      });
    };
  }

  onPageChange(event) {
    this.currentLocations = this.filtered; //.slice(event.first, +event.first + +event.rows);
  }

  onPanelHide() {
    this.filterValue = '';
    this.currentLocations = this.locations; //.slice(0, this.paginatorRows);
  }

  onFilter(event) {
    const searchStr = event.target.value.toLowerCase();
    const pattern = new RegExp('\\b' + searchStr);
    this.filtered = [
      ...this.locations.filter(
        (elem) => elem.join(' ').toLowerCase().match(pattern)
      ),
    ];
    // this.paginatorLength = this.filtered.length;
    this.currentLocations = this.filtered; //.slice(0, this.paginatorRows);
  }

  public handleLocChange(event): void {
    if (event.value.length === this.locations.length) {
      this.scheduleGroup.controls.isSelectedAll.setValue(true, { emitEvent: false });
    }
  }

  public hendleScheduleLater(): void {
    // console.log(this.scheduleGroup.controls['checked']);
    // if(!this.scheduleGroup.controls['checked'].value) {
    //   this.scheduleGroup.patchValue({
    //     timeZones: null
    //   })
    // }
  }

  handleAllLocChange(event) {
    // console.log(event);
    // console.log(this.scheduleGroup.controls.location.value);

    // this.scheduleGroup.controls.isSelectedAll.setValue(event.checked, {emitEvent: false});
    // this.scheduleGroup.patchValue({
    //   location: [...this.scheduleGroup.controls.location.value, ...this.preSelectedLocs]
    // });
    // console.log(this.scheduleGroup.controls.location.value);
  }

  onCreateLocationFilter(): void {
    // When opening, capture a draft snapshot to restore on cancel
    this.draftSelectedFilters = JSON.parse(JSON.stringify(this.selectedFilters || {}));
    this.showLocationFilterModal = true;
  }

  // Load locations from /access/filters API
  private loadLocationsFromFiltersAPI(): void {
    const accountId = this.currentAccountId;
    const userId = this.userLoginId;

    if (!accountId || !userId) {
      console.warn('Account ID or User ID not available for loading locations');
      return;
    }

    // Reset filtered locations when loading all locations
    this.filteredLocations = [];
    this.selectedFilteredLocationsForDisplay = [];
    this.showFilteredLocationsDropdown = false;

    // Use cache by default - this will return cached data if available and not expired
    this.locationsFilterService
      .getFilters(accountId, userId, true)
      .then((res) => {
        // Mark as loaded to avoid redundant processing
        this.locationsLoaded = true;
        
        let locations = [];
        let totalCount = 0;
        
        // Check if API returns locations array directly
        if (res.locations && Array.isArray(res.locations)) {
          locations = this.transformLocationsFromAPI(res.locations);
          totalCount = res.locations.length; // Get count from API response
        } else {
          // If API doesn't return locations directly, try to construct from filter data
          console.log('No locations array found. Available data:', {
            storecode: res.storecode,
            business_names: res.business_names,
            city: res.city,
            states: res.states,
            countries: res.countries,
            tag_list: res.tag_list,
            label_list: res.label_list
          });
          
          // Try to construct locations from filter data
          locations = this.constructLocationsFromFilterData(res);
          // Count from storecode array as it's the most reliable indicator
          totalCount = (res.storecode && Array.isArray(res.storecode)) ? res.storecode.length : locations.length;
        }
        
        // Store the total count from API
        this.totalLocationsCount = totalCount;
        
        // Process locations
        this.processLocations(locations);
        
        // Also populate filter options from the API response
        this.setFilterOptions('storeCode', (res.storecode || []).map(String).sort());
        this.setFilterOptions('businessName', (res.business_names || []).map(String).sort());
        this.setFilterOptions('city', (res.city || []).map(String).sort());
        this.setFilterOptions('state', (res.states || []).map(String).sort());
        this.setFilterOptions('country', (res.countries || []).map(String).sort());
        this.setFilterOptions('tags', (res.tag_list || []).map(String).sort());
        this.setFilterOptions('labels', (res.label_list || []).map(String).sort());
      })
      .catch((err) => {
        console.error('Error fetching locations from filters API:', err);
      });
  }

  // Transform locations from API response to expected format
  private transformLocationsFromAPI(apiLocations: any[]): any[] {
    return apiLocations.map((loc: any, index: number) => {
      return [
        loc.location_id || loc._id || loc.id || index + 1, // Use location_id for CTA, startdate, enddate
        loc.storeCode || loc.storecode || '',
        loc.businessName || loc.business_name || '',
        loc.city || '',
        loc.state || '',
        Array.isArray(loc.tags) ? loc.tags.join(',') : (loc.tags || ''),
        Array.isArray(loc.labels) ? loc.labels.join(',') : (loc.labels || '')
      ];
    });
  }

  // Construct locations from filter data (if locations array is not available)
  private constructLocationsFromFilterData(res: any): any[] {
    const locations: any[] = [];
    const storeCodes = res.storecode || [];
    const businessNames = res.business_names || [];
    const cities = res.city || [];
    const states = res.states || [];
    const tags = res.tag_list || [];
    const labels = res.label_list || [];

    // Create locations by combining filter data
    // This is a fallback approach - ideally the API should return locations array
    const maxLength = Math.max(
      storeCodes.length,
      businessNames.length,
      cities.length,
      states.length
    );

    for (let i = 0; i < maxLength; i++) {
      locations.push([
        i + 1,
        storeCodes[i] || '',
        businessNames[i] || '',
        cities[i] || '',
        states[i] || '',
        Array.isArray(tags) ? (tags[i] || '') : '',
        Array.isArray(labels) ? (labels[i] || '') : ''
      ]);
    }

    return locations;
  }

  // Process locations (common logic)
  private processLocations(locations: any[]): void {

    this.scheduleGroup.addControl('totalLocationsCount', new FormControl(locations.length));
    if (this.scheduleGroup.controls['preSelectedLocation']?.value?.length) {
      this.preSelectedLocs = this.scheduleGroup.controls['preSelectedLocation']?.value;
      this.preSelectedLocs.forEach(loc => {
        locations.forEach((l, i) => {
          if(l[1] === loc?.storeCode) {
            locations.splice(i, 1);
          }
        })
      });
    }

    this.locations = locations;
    if (this.locations?.length === this.preSelectedLocs?.length) {
      this.scheduleGroup.patchValue({
        isSelectedAll:  true
      })
    }

    this.timeZones = TIME_ZONES;
    this.currentLocations = this.locations;
    this.filtered = this.locations;
    
    // Initialize filter options with static data
    this.initializeFilterOptions();
  }

  // Initialize filter options with static data
  private initializeFilterOptions(): void {
    // Extract unique values from static locations data
    const storeCodes = new Set<string>();
    const businessNames = new Set<string>();
    const cities = new Set<string>();
    const states = new Set<string>();
    const countries = new Set<string>();
    const tags = new Set<string>();
    const labels = new Set<string>();

    this.locations.forEach((loc: any[]) => {
      if (loc[1]) storeCodes.add(loc[1]); // storeCode
      if (loc[2]) businessNames.add(loc[2]); // businessName
      if (loc[3]) cities.add(loc[3]); // city
      if (loc[4]) states.add(loc[4]); // state
      if (loc[5]) tags.add(loc[5]); // tags
      if (loc[6]) labels.add(loc[6]); // labels
    });

    // Add some static options for demonstration
    countries.add('Canada');
    countries.add('USA');

    // Set options for each category
    this.setFilterOptions('storeCode', Array.from(storeCodes).sort());
    this.setFilterOptions('businessName', Array.from(businessNames).sort());
    this.setFilterOptions('city', Array.from(cities).sort());
    this.setFilterOptions('state', Array.from(states).sort());
    this.setFilterOptions('country', Array.from(countries).sort());
    this.setFilterOptions('tags', Array.from(tags).sort());
    this.setFilterOptions('labels', Array.from(labels).sort());
  }

  private setFilterOptions(key: string, options: string[]): void {
    const cat = this.filterCategories.find((c) => c.key === key);
    if (cat) {
      cat.options = options;
    }
  }

  // Modal methods
  closeModalOnBackdrop(event: MouseEvent): void {
    if (this.applyFiltersLoading) return;
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.cancelFilters();
    }
  }

  toggleBooleanMode(): void {
    this.isAndMode = !this.isAndMode;
  }

  get hasStoreCodeFilter(): boolean {
    return (this.selectedFilters?.storeCode?.length ?? 0) > 0;
  }

  get hasOtherFilters(): boolean {
    return Object.keys(this.selectedFilters || {}).some(
      (k) => k !== 'storeCode' && (this.selectedFilters[k]?.length ?? 0) > 0
    );
  }

  // Filter selection methods
  onSelectFilter(key: string, checked: boolean, value: string): void {
    // Enforce mutual exclusivity
    this.ensureExclusive(key);

    if (!this.selectedFilters[key]) this.selectedFilters[key] = [];

    if (checked) {
      // avoid dupes
      if (!this.selectedFilters[key].includes(value)) {
        this.selectedFilters[key].push(value);
      }
    } else {
      this.selectedFilters[key] = this.selectedFilters[key].filter((v) => v !== value);
    }
  }

  isSelected(key: string, value: string): boolean {
    return this.selectedFilters[key]?.includes(value) || false;
  }

  toggleSelectAll(key: string, checked: boolean): void {
    // Enforce exclusivity before selecting all
    if (checked) this.ensureExclusive(key);

    const cat = this.filterCategories.find((c) => c.key === key);
    if (!cat) {
      return;
    }

    if (!this.selectedFilters[key]) this.selectedFilters[key] = [];

    this.selectedFilters[key] = checked ? (cat.options?.slice() || []) : [];
  }

  isAllSelected(key: string): boolean {
    const cat = this.filterCategories.find((c) => c.key === key);
    if (!cat) return false;
    return cat.options.length > 0 && cat.options.every((opt) => this.selectedFilters[key]?.includes(opt));
  }

  private ensureExclusive(activeKey: string): void {
    if (activeKey === 'storeCode' && this.hasOtherFilters) {
      this.clearNonStoreFilters();
    } else if (activeKey !== 'storeCode' && this.hasStoreCodeFilter) {
      this.clearStoreCodes();
    }
  }

  private clearStoreCodes(): void {
    if (!this.selectedFilters) this.selectedFilters = {};
    this.selectedFilters['storeCode'] = [];
  }

  private clearNonStoreFilters(): void {
    if (!this.selectedFilters) this.selectedFilters = {};
    Object.keys(this.selectedFilters).forEach((k) => {
      if (k !== 'storeCode') this.selectedFilters[k] = [];
    });
  }

  cancelFilters(): void {
    this.selectedFilters = JSON.parse(JSON.stringify(this.draftSelectedFilters || {}));
    this.showLocationFilterModal = false;
  }

  clearAllFilters(): void {
    this.selectedFilters = {};
    this.collapseAllCategories();
  }

  private collapseAllCategories(): void {
    this.filterCategories.forEach((c) => (c.expanded = false));
    this.filterCategories = [...this.filterCategories];
  }

  /**
   * Maps one API location entry to the internal `[id, storeCode, businessName, city, state, tags, labels]` tuple.
   *
   * @param loc Location object or existing tuple row from GET /apple/ctas-data-from-filters.
   * @returns Normalized tuple used by the rest of the form and submit payloads.
   */
  private normalizeLocationRowFromCtasResponse(loc: any): any[] {
    if (Array.isArray(loc)) {
      return loc;
    }
    return [
      loc.location_id || loc._id || loc.id || '',
      loc.storeCode || loc.storecode || '',
      loc.businessName || loc.business_name || '',
      loc.city || '',
      loc.state || '',
      Array.isArray(loc.tags) ? loc.tags.join(',') : loc.tags || '',
      Array.isArray(loc.labels) ? loc.labels.join(',') : loc.labels || '',
    ];
  }

  /**
   * Reads `locations` / `data` / array root from a ctas-data-from-filters response into tuple rows.
   *
   * @param res Parsed JSON from GET /apple/ctas-data-from-filters.
   * @returns Possibly empty list of location tuples.
   */
  private extractLocationRowsFromCtasDataResponse(res: any): any[] {
    if (res?.locations && Array.isArray(res.locations)) {
      return res.locations.map((loc: any) => this.normalizeLocationRowFromCtasResponse(loc));
    }
    if (res?.data && Array.isArray(res.data)) {
      return res.data.map((loc: any) => this.normalizeLocationRowFromCtasResponse(loc));
    }
    if (Array.isArray(res)) {
      return res.map((loc: any) => this.normalizeLocationRowFromCtasResponse(loc));
    }
    return [];
  }

  /**
   * Calls GET /apple/ctas-data-from-filters with no filter query (empty object) when the user selects
   * all locations, then refreshes `locations`, the location control, and `ctaSummaryFromFilterApply`.
   */
  private fetchCtasDataForSelectAll(): void {
    const accountId = this.currentAccountId;
    const userId = this.userLoginId;
    if (!accountId || !userId) {
      return;
    }
    const queryParams: { [key: string]: string } = {};
    this.locationsFilterService
      .getCtasDataFromFilters(accountId, userId, queryParams)
      .then((res) => this.applySelectAllCtasDataResponse(res))
      .catch(() => {
        this.setCtaSummaryFromFilterApply(null);
      });
  }

  /**
   * Applies GET /apple/ctas-data-from-filters (no filters) after select-all: updates master location lists,
   * clears filter-mode UI, and stores `ctas` for PostInfo.
   *
   * @param res Full JSON body including `locations` and `ctas`.
   */
  private applySelectAllCtasDataResponse(res: any): void {
    const rows = this.extractLocationRowsFromCtasDataResponse(res);
    this.filteredLocations = [];
    this.showFilteredLocationsDropdown = false;
    this.selectedFilteredLocationsForDisplay = [];

    if (rows.length > 0) {
      this.locations = rows;
      this.filtered = rows;
      this.currentLocations = rows;
      this.scheduleGroup.controls.location.setValue(rows);
      if (this.scheduleGroup.controls['totalLocationsCount']) {
        this.scheduleGroup.controls['totalLocationsCount'].setValue(rows.length);
      }
      if (this.scheduleGroup.controls['locationFilterKeys']) {
        this.scheduleGroup.controls['locationFilterKeys'].setValue([]);
      }
    }

    this.setCtaFiltersQueryParamsSnapshot({});
    this.setCtaSummaryFromFilterApply(res?.ctas != null ? { ...res.ctas } : null);
  }

  applyFilters(): void {
    
    // Build query parameters
    const queryParams: { [key: string]: string } = {};
    
    // Add operand parameter
    queryParams['operand'] = this.isAndMode ? 'AND' : 'OR';
    
    // Add filter parameters based on selected filters
    if (this.selectedFilters.storeCode?.length > 0) {
      queryParams['storecode'] = this.selectedFilters.storeCode.join(',');
    }
    
    if (this.selectedFilters.businessName?.length > 0) {
      queryParams['businessname'] = this.selectedFilters.businessName.join(',');
    }
    
    if (this.selectedFilters.city?.length > 0) {
      queryParams['city'] = this.selectedFilters.city.join(',');
    }
    
    if (this.selectedFilters.state?.length > 0) {
      queryParams['state'] = this.selectedFilters.state.join(',');
    }
    
    if (this.selectedFilters.country?.length > 0) {
      queryParams['country'] = this.selectedFilters.country.join(',');
    }
    
    if (this.selectedFilters.tags?.length > 0) {
      queryParams['tags'] = this.selectedFilters.tags.join(',');
    }
    
    if (this.selectedFilters.labels?.length > 0) {
      queryParams['labels'] = this.selectedFilters.labels.join(',');
    }
    
    // Use account and user ids the same way as listings
    const accountId = this.currentAccountId;
    const userId = this.userLoginId;

    if (!accountId || !userId) {
      return;
    }

    this.applyFiltersLoading = true;

    this.locationsFilterService
      .getCtasDataFromFilters(accountId, userId, queryParams)
      .then((res) => {
        this.applyFiltersLoading = false;

        let filteredLocations = this.extractLocationRowsFromCtasDataResponse(res);
        if (filteredLocations.length === 0) {
          filteredLocations = this.filterLocationsClientSide(this.locations, this.selectedFilters);
        }

        if (filteredLocations.length > 0) {
          // Store filtered locations and update the locations array
          this.filteredLocations = filteredLocations;
          this.locations = filteredLocations;
          this.currentLocations = filteredLocations;
          this.filtered = filteredLocations;
          
          // Set all filtered locations for display in dropdown (pre-selected)
          this.selectedFilteredLocationsForDisplay = this.getFilteredLocationsForDisplay();
          
          // Automatically set filtered locations in the form control
          // This passes the location IDs to the form data
          this.scheduleGroup.controls.location.setValue(filteredLocations);
          
          // Don't automatically check "Select all" checkbox
          // Let the user decide if they want to select all filtered locations
          this.scheduleGroup.controls.isSelectedAll.setValue(false, { emitEvent: false });
          
          // Show the filtered locations list
          this.showFilteredLocationsDropdown = true;
          
          // Update total locations count
          if (this.scheduleGroup.controls['totalLocationsCount']) {
            this.scheduleGroup.controls['totalLocationsCount'].setValue(filteredLocations.length);
          }

          // Store applied filter keys for submit step label (e.g. ['city'], ['state'], ['city', 'state'])
          const filterKeys = this.getLocationFilterKeys();
          if (!this.scheduleGroup.controls['locationFilterKeys']) {
            this.scheduleGroup.addControl('locationFilterKeys', new FormControl(filterKeys));
          } else {
            this.scheduleGroup.controls['locationFilterKeys'].setValue(filterKeys);
          }
          
        } else {
          this.filteredLocations = [];
          this.showFilteredLocationsDropdown = false;
          this.scheduleGroup.controls.location.setValue([]);
          if (this.scheduleGroup.controls['totalLocationsCount']) {
            this.scheduleGroup.controls['totalLocationsCount'].setValue(0);
          }
          if (this.scheduleGroup.controls['locationFilterKeys']) {
            this.scheduleGroup.controls['locationFilterKeys'].setValue([]);
          }
        }

        this.setCtaFiltersQueryParamsSnapshot(queryParams);
        this.setCtaSummaryFromFilterApply(res?.ctas != null ? { ...res.ctas } : null);

        // Close modal once we have the response
        this.showLocationFilterModal = false;
      })
      .catch(() => {
        this.applyFiltersLoading = false;
        this.filteredLocations = [];
        this.showFilteredLocationsDropdown = false;
        this.setCtaSummaryFromFilterApply(null);
      });
  }
  
  // Transform location array to object format for dropdown display
  transformLocationForDisplay(loc: any[]): any {
    const storeCode = loc[1] || '';
    const businessName = loc[2] || '';
    const city = loc[3] || '';
    const state = loc[4] || '';
    const displayText = `${storeCode} - ${businessName} - ${city}, ${state}`;
    
    return {
      _id: loc[0] || '',
      storeCode: storeCode,
      businessName: businessName,
      city: city,
      state: state,
      tags: loc[5] || '',
      labels: loc[6] || '',
      displayText: displayText
    };
  }
  
  // Get filtered locations in object format for dropdown
  getFilteredLocationsForDisplay(): any[] {
    return this.filteredLocations.map(loc => this.transformLocationForDisplay(loc));
  }
  
  // Handle changes to filtered locations dropdown (keep all selected for display)
  onFilteredLocationsChange(event: any[]): void {
    // Always keep all filtered locations selected for display
    // This ensures the list is always visible
    this.selectedFilteredLocationsForDisplay = this.getFilteredLocationsForDisplay();
  }
  
  // Clear filters and reset to all locations
  clearLocationFilters(): void {
    // Clear all filter selections
    this.selectedFilters = {};
    this.draftSelectedFilters = {};
    
    // Clear filtered locations
    this.filteredLocations = [];
    this.selectedFilteredLocationsForDisplay = [];
    this.showFilteredLocationsDropdown = false;
    
    // Reset form controls
    this.scheduleGroup.controls.location.setValue([]);
    this.scheduleGroup.controls.isSelectedAll.setValue(false, { emitEvent: false });
    if (this.scheduleGroup.controls['locationFilterKeys']) {
      this.scheduleGroup.controls['locationFilterKeys'].setValue([]);
    }

    this.setCtaFiltersQueryParamsSnapshot({});
    this.setCtaSummaryFromFilterApply(null);
    
    // Reload all locations from API to reset everything
    this.loadLocationsFromFiltersAPI();
  }

  /**
   * Persists the `ctas` object from GET /apple/ctas-data-from-filters so PostInfo can build the CTA
   * dropdown from `cta_summary` without a second HTTP call.
   *
   * @param ctas `res.ctas` from the filter apply response, or `null` after Clear Filter / error.
   */
  private setCtaSummaryFromFilterApply(ctas: Record<string, unknown> | null): void {
    if (!this.scheduleGroup.get('ctaSummaryFromFilterApply')) {
      this.scheduleGroup.addControl('ctaSummaryFromFilterApply', new FormControl(ctas));
    } else {
      this.scheduleGroup.get('ctaSummaryFromFilterApply')!.setValue(ctas);
    }
  }

  /**
   * Persists the filter query map for debugging / consistency (same encoding as the Apple filter request).
   *
   * @param queryParams Shallow key/value strings (e.g. operand, storecode, city). Pass `{}` after Clear Filter.
   */
  private setCtaFiltersQueryParamsSnapshot(queryParams: { [key: string]: string }): void {
    const snap = { ...queryParams };
    if (!this.scheduleGroup.get('ctaFiltersQueryParams')) {
      this.scheduleGroup.addControl('ctaFiltersQueryParams', new FormControl(snap));
    } else {
      this.scheduleGroup.get('ctaFiltersQueryParams')!.setValue(snap);
    }
  }

  /** Used by submit step: keys of applied filters (e.g. ['storeCode'], ['city', 'state']). */
  getLocationFilterKeys(): string[] {
    const keys = this.filterCategories.map((c) => c.key);
    return keys.filter((key) => (this.selectedFilters?.[key]?.length ?? 0) > 0);
  }

  // Filter locations client-side based on selected filters
  private filterLocationsClientSide(locations: any[], selectedFilters: { [key: string]: string[] }): any[] {
    if (!locations || locations.length === 0) {
      return [];
    }

    let filtered = [...locations];

    // Apply store code filter
    if (selectedFilters.storeCode?.length > 0) {
      filtered = filtered.filter((loc) => {
        const storeCode = loc[1] || ''; // storeCode is at index 1
        return selectedFilters.storeCode.includes(storeCode);
      });
    }

    // Apply business name filter
    if (selectedFilters.businessName?.length > 0) {
      filtered = filtered.filter((loc) => {
        const businessName = loc[2] || ''; // businessName is at index 2
        return selectedFilters.businessName.includes(businessName);
      });
    }

    // Apply city filter
    if (selectedFilters.city?.length > 0) {
      filtered = filtered.filter((loc) => {
        const city = loc[3] || ''; // city is at index 3
        return selectedFilters.city.includes(city);
      });
    }

    // Apply state filter
    if (selectedFilters.state?.length > 0) {
      filtered = filtered.filter((loc) => {
        const state = loc[4] || ''; // state is at index 4
        return selectedFilters.state.includes(state);
      });
    }

    // Apply country filter (if we have country data in locations)
    if (selectedFilters.country?.length > 0) {
      // Note: Country might not be in the location array structure
      // Adjust based on your actual location structure
      filtered = filtered.filter((loc) => {
        // If country is stored in locations, filter by it
        // Otherwise, skip this filter
        return true; // Placeholder - adjust based on your data structure
      });
    }

    // Apply tags filter
    if (selectedFilters.tags?.length > 0) {
      filtered = filtered.filter((loc) => {
        const tags = (loc[5] || '').split(',').map((t: string) => t.trim()); // tags at index 5
        return selectedFilters.tags.some((tag) => tags.includes(tag));
      });
    }

    // Apply labels filter
    if (selectedFilters.labels?.length > 0) {
      filtered = filtered.filter((loc) => {
        const labels = (loc[6] || '').split(',').map((l: string) => l.trim()); // labels at index 6
        return selectedFilters.labels.some((label) => labels.includes(label));
      });
    }

    return filtered;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
